import { styled } from '@mui/material/styles';

export const StyledRowSpace = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}));
